module.exports = __webpack_public_path__ + "img/engagement-photo-10.1bad3e87.jpg";